import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button, Row } from "components/bootstrap";
import Routes from "routing/Routes";
import useInputSetupWizard from "components/inputs/InputSetupWizard/hooks/useInputSetupWizard";
import { StepWrapper, DescriptionCol, ButtonCol } from "./components/StepWrapper";
const InputDiagnosisStep = ({ onClose }) => {
  const { t } = useTranslation("inputs");
  const {
    wizardData: { input }
  } = useInputSetupWizard();
  return /* @__PURE__ */ React.createElement(StepWrapper, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(DescriptionCol, { md: 12 }, /* @__PURE__ */ React.createElement("p", null, t("setup_wizard.diagnosis_step.description")))), (input == null ? void 0 : input.id) && /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xs",
      bsStyle: "primary",
      onClick: () => window.open(Routes.SYSTEM.INPUT_DIAGNOSIS(input == null ? void 0 : input.id), "_blank")
    },
    t("setup_wizard.diagnosis_step.go_to_diagnosis")
  ), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(ButtonCol, { md: 12 }, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, t("setup_wizard.finish")))));
};
export default InputDiagnosisStep;
